import React, {useState} from "react";
import {
    AppBar, 
    Box, 
    Toolbar,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import { NavOptions } from "./NavOptions.js";
import { AccountStatus } from "./AccountStatus.js";

export const MainMenu = ({loggedInUser, setLoggedInUser, setUserProfile, userProfile, setHideCreatePaidAccount}) => {
    const isMobile = useMediaQuery("(max-width:1000px)");
    const [accordionExpanded, setAccordionExpanded] = useState(false);

    const menu_options = (
        <>
            <NavOptions setMainMenuAccordionExpanded={setAccordionExpanded} />
            <Box sx={{flexGrow: 1, display: {xs: "flex"}}}></Box>
            <AccountStatus
                setMainMenuAccordionExpanded={setAccordionExpanded}
                loggedInUser={loggedInUser}
                userProfile={userProfile}
                setHideCreatePaidAccount={setHideCreatePaidAccount}
                setLoggedInUser={setLoggedInUser}
                setUserProfile={setUserProfile}
            />
            <div className="beta">Public Beta</div>
        </>
    );

    return <Box className='main-menu'>{isMobile 
        ? <Accordion expanded={accordionExpanded} onChange={() => setAccordionExpanded(!accordionExpanded)}>
            <AccordionSummary
                expandIcon={<MenuIcon />}
                aria-controls="menu-content"
                id="menu-header"
            >
                <Box>
                    <img src={"/public/canold-logo.webp"} id="logo-header-modile"/>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                {menu_options}
            </AccordionDetails>
        </Accordion>
        : <AppBar position={"static"} className={"top-rail"}>
            <Toolbar disableGutters>
                <Box>
                    <img src={"/public/canold-logo.webp"}/>
                </Box>
                {menu_options}
            </Toolbar>
        </AppBar>
    }
    </Box>
};

export default MainMenu;
